// Brand colors definition
export const COLORS = {
  primary: '#ce2223',
  secondary: '#fdb52a'
};

// Enhanced color utility function with hardcoded class strings for brand colors
export const getColor = (color) => {
  const colors = {
    primary: {
      light: "bg-red-100 text-red-800",
      medium: "bg-red-600 text-white",
      dark: "bg-red-700 text-white",
      border: "border-red-200",
      hover: "hover:bg-red-700",
      gradient: "from-red-500 to-red-700",
      text: "text-red-600",
      softBg: "bg-red-50",
      softBgGradient: "bg-gradient-to-r from-red-50 to-white",
      bgGradient: "bg-gradient-to-br from-red-500 to-red-700",
      lightBorder: "border-red-100",
      badge: "bg-red-50 text-red-800 border-red-100",
      buttonPrimary: "bg-red-600 hover:bg-red-700 text-white",
      buttonSecondary: "bg-red-50 hover:bg-red-100 text-red-800 border-red-100"
    },
    secondary: {
      light: "bg-amber-100 text-amber-800",
      medium: "bg-amber-500 text-white",
      dark: "bg-amber-700 text-white",
      border: "border-amber-200",
      hover: "hover:bg-amber-600",
      gradient: "from-amber-500 to-amber-700",
      text: "text-amber-600",
      softBg: "bg-amber-50",
      softBgGradient: "bg-gradient-to-r from-amber-50 to-white",
      bgGradient: "bg-gradient-to-br from-amber-500 to-amber-700",
      lightBorder: "border-amber-100",
      badge: "bg-amber-50 text-amber-800 border-amber-100",
      buttonPrimary: "bg-amber-600 hover:bg-amber-700 text-white",
      buttonSecondary: "bg-amber-50 hover:bg-amber-100 text-amber-800 border-amber-100"
    }
  };
  return colors[color] || colors.primary;
};

// Get time horizon badge style
export const getTimeHorizonStyle = (horizon) => {
  const styles = {
    "Short-term": "bg-green-100 text-green-800",
    "Medium-term": "bg-amber-100 text-amber-800",
    "Long-term": "bg-purple-100 text-purple-800"
  };
  return styles[horizon] || "bg-gray-100 text-gray-800";
};

// Get disruption level color
export const getDisruptionColor = (level) => {
  const colors = {
    "Low": "bg-blue-100 text-blue-800",
    "Medium": "bg-amber-100 text-amber-800",
    "Medium-High": "bg-orange-100 text-orange-800",
    "High": "bg-rose-100 text-rose-800"
  };
  return colors[level] || "bg-gray-100 text-gray-800";
};